export default __webpack_public_path__ + "static/media/arrow-left.c73408e3.svg";